// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const escavalier: PokeData = {
  "id": 589,
  "name": "escavalier",
  "height": 10,
  "weight": 330,
  "base_experience": 173,
  "types": [
    PokeType.BUG,
    PokeType.STEEL
  ],
  "api_moves": [
    "swords-dance",
    "headbutt",
    "fury-attack",
    "take-down",
    "double-edge",
    "twineedle",
    "leer",
    "peck",
    "slash",
    "flail",
    "reversal",
    "scary-face",
    "endure",
    "false-swipe",
    "fury-cutter",
    "iron-defense",
    "metal-burst",
    "x-scissor",
    "bug-buzz",
    "giga-impact",
    "iron-head",
    "acid-spray",
    "quick-guard",
    "fell-stinger"
  ],
  "moves": [
    "headbutt",
    "leer",
    "peck",
    "scary-face",
    "metal-burst",
    "bug-buzz",
    "iron-defense",
    "metal-sound",
    "steel-beam",
    "sticky-web",
    "smart-strike",
    "pounce",
    "string-shot"
  ],
  "evolution_chain": {
    "id": 299,
    "item": null,
    "species": [
      {
        "name": "karrablast",
        "order": 589,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "escavalier",
        "order": 590,
        "types": [
          PokeType.BUG,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 588,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": 616,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 144,
    "speed": 33,
    "ability_power": 223
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
